import { useContext } from "react"

import {
    createStateContext,
    createDispatchContext,
    AdminProvider
} from "components/partials/AdminProvider"

const StateContext = createStateContext()
const DispatchContext = createDispatchContext()

export const useAdminState = () => useContext(StateContext)
export const useAdminDispatch = () => useContext(DispatchContext)

export const Provider = ({ children }) => {
    return (
        <AdminProvider
            StateContext={StateContext}
            DispatchContext={DispatchContext}
        >
            {children}
        </AdminProvider>
    )
}
